"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveSearchSetToRemote = exports.saveSearchDialogSagas = void 0;
var effects_1 = require("redux-saga/effects");
var SaveSearchDialogAction_1 = require("@/pages/search/actions/sfilter/SaveSearchDialogAction");
var SaveSearchSet_1 = require("@/pages/common/states/SaveSearchSet");
var SaveSearchApiSaga_1 = require("@/pages/search/sagas/api/SaveSearchApiSaga");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var SfavAction_1 = require("@/pages/search/actions/sfilter/SfavAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var SearchAction_1 = require("@/pages/search/actions/SearchAction");
var RootSaga_1 = require("@/pages/common/sagas/RootSaga");
var RootSaveSearchCallSaga_1 = require("@/pages/savesearch/sagas/RootSaveSearchCallSaga");
var SearchQueryAction_1 = require("@/pages/search/actions/sfilter/SearchQueryAction");
var getSearchId = function (state) { return state.savesearch.currentSearchId; };
var getHfilter = function (state) { return state.hfilter; };
var watchOnSaveSearchClose = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(SaveSearchDialogAction_1.default.ON_SAVE_SEARCH_CLOSE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.onSetActive(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.onSetDim(false))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setError(''))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var saveSearchSetToRemote = function (saveSearchSet, silent, errorOnDuplicate) {
    var response, userSearchSetId, t;
    if (silent === void 0) { silent = false; }
    if (errorOnDuplicate === void 0) { errorOnDuplicate = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setIsLoading(true))];
            case 1:
                _a.sent();
                if (saveSearchSet.searchSaveSetType === null || saveSearchSet.searchSaveSetType === undefined) {
                    saveSearchSet.searchSaveSetType = SaveSearchSet_1.SearchSaveSetType.Search;
                }
                return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.saveSearchCriteriaApi, saveSearchSet)];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setIsLoading(false))];
            case 3:
                _a.sent();
                if (!(response.data.result &&
                    response.data.result.hasError === false &&
                    ((!errorOnDuplicate && response.data.duplicateResult.item2.length) ||
                        response.data.duplicateResult.item2.length === 0))) return [3 /*break*/, 12];
                if (!response.data.userSearchSets.length) return [3 /*break*/, 5];
                userSearchSetId = response.data.userSearchSets[response.data.userSearchSets.length - 1].userSearchSetId;
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.saveSearchSuccess(userSearchSetId))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                if (!!silent) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_search_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'searchSavedSuccess'))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.onSetActive(false))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.onSetDim(false))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SfavAction_1.default.setSaveSearchFromRemote())];
            case 11:
                _a.sent();
                return [3 /*break*/, 20];
            case 12:
                if (!(response.data.duplicateResult.item2 && response.data.duplicateResult.item2.length)) return [3 /*break*/, 18];
                return [4 /*yield*/, effects_1.select(RootSaga_1.getGlobalTranslation)];
            case 13:
                t = _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setError(t['searchSavedDuplicated']))];
            case 14:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setSaveNewEnabled(false))];
            case 15:
                _a.sent();
                if (!!silent) return [3 /*break*/, 17];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_search_failed_duplicated', BigPopupState_1.BigPopupType.FAILED, 'failed', 'searchSavedDuplicated'))];
            case 16:
                _a.sent();
                _a.label = 17;
            case 17: return [3 /*break*/, 20];
            case 18: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('searchSavedFailed'))];
            case 19:
                _a.sent();
                _a.label = 20;
            case 20: return [2 /*return*/, response];
        }
    });
};
exports.saveSearchSetToRemote = saveSearchSetToRemote;
var saveSearchSaga = function (name, searchId, errorOnDuplicate) {
    var saveSearchSet;
    if (searchId === void 0) { searchId = 0; }
    if (errorOnDuplicate === void 0) { errorOnDuplicate = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(RootSaveSearchCallSaga_1.getSaveSearchSet, name, searchId)];
            case 1:
                saveSearchSet = _a.sent();
                return [4 /*yield*/, effects_1.call(saveSearchSetToRemote, saveSearchSet, false, errorOnDuplicate)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
};
var watchOnSaveSearchSaveNew = function () {
    var payload, errorOnDuplicate, response, newSearchSetId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(SaveSearchDialogAction_1.default.ON_SAVE_SEARCH_SAVE_NEW_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                errorOnDuplicate = true;
                return [4 /*yield*/, effects_1.call(saveSearchSaga, payload, 0, errorOnDuplicate)];
            case 2:
                response = _a.sent();
                if (!(response && response.isSaved && response.userSearchSets[0].userSearchSetId)) return [3 /*break*/, 5];
                newSearchSetId = Number(response.userSearchSets[0].userSearchSetId);
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setCurrentSearchId(newSearchSetId))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setSearchSetIdHash, newSearchSetId)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchOnSaveSearchSave = function () {
    var payload, searchId, response, searchSet;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(SaveSearchDialogAction_1.default.ON_SAVE_SEARCH_SAVE_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.select(getSearchId)];
            case 2:
                searchId = _a.sent();
                return [4 /*yield*/, effects_1.call(saveSearchSaga, payload, searchId)];
            case 3:
                response = _a.sent();
                if (!(!searchId && response.data.isSaved)) return [3 /*break*/, 7];
                searchSet = response.data.userSearchSets[response.data.userSearchSets.length - 1];
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.onCustomNameChanged(searchSet.name))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setCurrentSearchId(searchSet.userSearchSetId))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setNotificationSetting(searchSet.notificationId, searchSet.notificationEnabled, searchSet.notificationFrequency))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchUpdateCriteria = function () {
    var filterState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(SearchQueryAction_1.default.SEARCH_QUERY)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getHfilter)];
            case 2:
                filterState = _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setFilterState(filterState))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchSearchSetUpdatedSetDialog = function () {
    var payload, searchSetDetail, userSearchSetId, customName, notifyId, enabled, freq;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(SearchAction_1.default.ON_SEARCH_SET_UPDATED)];
            case 1:
                payload = (_a.sent()).payload;
                searchSetDetail = payload;
                userSearchSetId = searchSetDetail.userSearchSetId;
                customName = searchSetDetail.name;
                notifyId = searchSetDetail.notificationId;
                enabled = searchSetDetail.notificationEnabled;
                freq = searchSetDetail.notificationFrequency;
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setCurrentSearchId(userSearchSetId))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.onCustomNameChanged(customName))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setNotificationSetting(notifyId, enabled, freq))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var saveSearchDialogSagas = {
    watchOnSaveSearchClose: watchOnSaveSearchClose,
    watchOnSaveSearchSave: watchOnSaveSearchSave,
    watchOnSaveSearchSaveNew: watchOnSaveSearchSaveNew,
    watchSearchSetUpdatedSetDialog: watchSearchSetUpdatedSetDialog,
    watchUpdateCriteria: watchUpdateCriteria,
};
exports.saveSearchDialogSagas = saveSearchDialogSagas;
